// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-module--footer--R2bpz","logo":"footer-module--logo--LCv7Q","info":"footer-module--info--3ISzk","social":"footer-module--social--2HcUH"};